import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  return user?.data?.token || null;
};

const getAuthHeaders = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const getEnquiries = async () => {
  const response = await axios.get(`${base_url}contactus/all`, getAuthHeaders());

  return response.data;
};
const deleteEnquiry = async (id) => {
  const response = await axios.delete(`${base_url}contactus/${id}`, getAuthHeaders());
  return response.data;
};
const getEnquiry = async (id) => {
  const response = await axios.get(`${base_url}contactus/get/${id}`, getAuthHeaders());
  return response.data;
};
const udpateEnquiry = async (enq) => {
  const response = await axios.put(
    `${base_url}contactus/edit/${enq.id}`,
    { status: enq.enqData },
    getAuthHeaders()
  );
  return response.data;
};
const enquiryService = {
  getEnquiries,
  deleteEnquiry,
  getEnquiry,
  udpateEnquiry,
};

export default enquiryService;
